enum RolesEnum {
  NoAccess = 0,
  ExplicitAccess = 1,
  Viewer = 2,
  Editor = 3,
  Admin = 4,
  SuperAdmin = 5,
}
export default RolesEnum
